import TaskForm, {
  TaskFormData,
} from '@/components/Operational/Tasks/TaskForm';
import { useCreateTask } from '@/core/domain/operational/Tasks/Tasks.hooks';
import {
  CreateTaskRequest,
  Task,
} from '@/core/domain/operational/Tasks/Tasks.types';
import { Form, Modal, ModalProps, notification } from 'antd';

export interface OnCallbackAddTask {
  onRefresh?: boolean;
  task: Task;
}

interface Props extends ModalProps {
  onCancel: () => void;
  onCallback?: (params: OnCallbackAddTask) => void;
}

const TaskSimpliedRegisterModal = (props: Props) => {
  const [form] = Form.useForm<TaskFormData>();

  const createTask = useCreateTask();

  const handleSaveClick = async () => {
    const values = await form.validateFields();

    const obj: CreateTaskRequest = {
      active: true,
      ...values,
      subArea: {
        id: +values.subAreaId,
      },
      taskPriceSet: values.taskPriceSet?.map((item) => ({
        companyId: item.companyId,
        price: item.price ?? 0,
        priceFixed: item.priceFixed ?? 0,
      })),
    };

    const result = await createTask.mutateAsync(obj);

    notification.success({
      message: 'Sucesso',
      description: 'Serviço criado',
    });

    if (props.onCallback) props.onCallback({ onRefresh: true, task: result });

    Modal.confirm({
      title: 'Cadastro de Serviço Concluído',
      content: 'Deseja abrir os detalhes do serviço em uma nova guia?',
      onOk: () => {
        props.onCancel();
        window.open(`/app/operational/tasks/{result.id}/general`, '_blank');
      },
      onCancel: () => {
        props.onCancel();
      },
      okText: 'Abrir',
    });
  };

  return (
    <Modal
      title="Cadastrar serviço"
      width="90%"
      {...props}
      okText="Cadastrar"
      onOk={handleSaveClick}
      destroyOnClose
      confirmLoading={createTask.isLoading}
    >
      <TaskForm form={form} isModal />
    </Modal>
  );
};

export default TaskSimpliedRegisterModal;
